import { handleErrorInfo } from '../../utils';
import { MarketingActionType } from './actions';
import { MarketingConfigState } from './interfaces';

const initialState: MarketingConfigState = {
  loading: true,
  error: false,
  errorInfo: undefined,
  merchantMarketingConfig: {},
  requestSuccess: false,
};

const MarketingConfigReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case MarketingActionType.GET_MERCHANT_MARKETING_CONFIG: {
      return {
        ...state,
        loading: true,
        error: false,
        errorInfo: undefined,
      };
    }
    case MarketingActionType.GET_MERCHANT_MARKETING_CONFIG_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: false,
        errorInfo: {},
        merchantMarketingConfig: action.response,
      };
    }
    case MarketingActionType.GET_MERCHANT_MARKETING_CONFIG_ERROR: {
      return {
        ...state,
        loading: false,
        error: true,
        errorInfo: null,
      };
    }
    case MarketingActionType.UPDATE_MERCHANT_MARKETING_CONFIG: {
      return {
        ...state,
        loading: true,
        requestSuccess: false,
        error: false,
        errorInfo: undefined,
      };
    }
    case MarketingActionType.UPDATE_MERCHANT_MARKETING_CONFIG_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: false,
        errorInfo: null,
        requestSuccess: true,
        merchantMarketingConfig: action.response,
      };
    }
    case MarketingActionType.UPDATE_MERCHANT_MARKETING_CONFIG_ERROR: {
      return {
        ...state,
        loading: false,
        error: true,
        errorInfo: handleErrorInfo(MarketingActionType.UPDATE_MERCHANT_MARKETING_CONFIG_ERROR, action.error),
      };
    }
    default:
      return state;
  }
};

export default MarketingConfigReducer;
